<h2 mat-dialog-title>Neue Vorlage anlegen</h2>
<form [formGroup]="form" data-test-id="add-vorlage-dialog">
	<mat-dialog-content>
		<mat-form-field appearance="outline" floatLabel="always">
			<mat-label>Beschreibung</mat-label>
			<input matInput formControlName="name" name="description" required
			       data-test-id="description"/>
			<mat-error>Bitte geben Sie die interne Bezeichnung der Vorlage ein.</mat-error>
		</mat-form-field>
		<schir-int-client-vorlage-file-upload (fileChanged)="updateVorlage($event)"/>
		@if (form.controls['file'].errors?.invalidExtension) {
			<mat-error>Es werden nur CSV- oder DOCX-Dateien unterstützt.</mat-error>
		}
	</mat-dialog-content>
	<mat-dialog-actions>
		<button mat-stroked-button (click)="onCancel()" class="focus-inwards-dark" data-test-id="cancel-button">
			Abbrechen
		</button>
		<button mat-flat-button color="primary" id="createVorlage" (click)="onSave()" type="submit"
		        [disabled]="!isValid()" class="focus-inwards-dark fix-contrast"
		        data-test-id="vorlage-einpflegen-button">
			Vorlage einpflegen
		</button>
	</mat-dialog-actions>
</form>
